/* Which desks does the signed-in person HANDLE? The SERVER decides.
 *
 * `staff` is the `staff` part of GET /api/access/me, produced by the same function
 * the ticket handlers use (`staffAccessFor` in api/src/shared/deskAccess.js). The
 * browser does not turn rooms into desks itself, so it cannot disagree with the
 * server - in particular about the two named admins, who are in no Hub room but
 * whom the server still lets in (the temporary safety net). Hiding is UX only; the
 * real boundary is each handler's 403.
 *
 * FAILS CLOSED: anything but a ready status with a well-formed `staff` handles
 * nothing. That includes an older API that does not send `staff` yet - so deploy
 * the API before the web app.
 */

// Keep these desk ids aligned with IT_REF_DESK / api/src/shared/deskAccess.js.
export const DESK_IDS = ['it-help', 'servicetitan-help', 'ai-access'];

const NONE = { isAdmin: false, isIT: false, myDesks: [] };

export function staffAccess(staff, status) {
  if (status !== 'ready' || !staff || typeof staff !== 'object') return NONE;
  const isAdmin = staff.all === true;
  const known = new Set(DESK_IDS);
  const named = Array.isArray(staff.desks) ? staff.desks.filter((d) => typeof d === 'string' && known.has(d)) : [];
  const myDesks = isAdmin ? [...DESK_IDS] : DESK_IDS.filter((d) => named.includes(d));
  return { isAdmin, myDesks, isIT: isAdmin || myDesks.length > 0 };
}
